/* Style Steals Editorial 3.3. No dependencies; Shopify owns prices, variants and cart. */
(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => Array.from(root.querySelectorAll(s));
  const config = JSON.parse($('#ssConfig')?.textContent || '{}');
  const labels = config.labels || {};
  const colorLabel = (template, color, min = '', max = '') => String(template).replace(/__COLOR__/g,color).replace(/__MIN__/g,min).replace(/__MAX__/g,max);
  const root = (window.Shopify?.routes?.root || config.root || '/').replace(/\/?$/, '/');
  const route = suffix => root + suffix;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const currency = config.currency || 'USD';
  const money = cents => new Intl.NumberFormat(config.locale || 'en', {style:'currency', currency}).format(Number(cents || 0) / 100);
  const icon = name => name === 'heart' ? '<svg class="ss-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.4 4.9a5.3 5.3 0 0 0-7.5 0l-.9.9-.9-.9a5.3 5.3 0 0 0-7.5 7.5L12 21l8.4-8.6a5.3 5.3 0 0 0 0-7.5Z" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>' : '<svg class="ss-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M12 5v14" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';
  const safeURL = value => {
    if (!value || typeof value !== 'string') return '';
    try { const url = new URL(value, location.origin); return ['http:','https:'].includes(url.protocol) ? url.href : ''; } catch { return ''; }
  };
  const sameOriginURL = value => {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin) throw new Error('This link is outside the store.');
    return url;
  };
  const productURL = handle => route('products/' + encodeURIComponent(handle));
  const productCache = new Map();
  const parse = (value, fallback = []) => { try { return JSON.parse(value) ?? fallback; } catch { return fallback; } };
  const storage = {
    get(key) { try { return localStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; } }
  };
  async function request(url, options = {}) {
    const response = await fetch(url, {credentials:'same-origin', ...options});
    const isJSON = response.headers.get('content-type')?.includes('json');
    const body = isJSON ? await response.json() : await response.text();
    if (!response.ok) throw new Error((body && typeof body === 'object' && (body.description || body.message)) || 'Something went wrong. Please try again.');
    return body;
  }
  async function product(handle) {
    if (!productCache.has(handle)) productCache.set(handle, request(productURL(handle) + '.js').catch(error => { productCache.delete(handle); throw error; }));
    return productCache.get(handle);
  }
  let toastTimer;
  function toast(message, undo) {
    const node = $('#ssToast'); if (!node) return;
    clearTimeout(toastTimer); node.textContent = message;
    if (undo) {
      const button = document.createElement('button'); button.textContent = 'Undo'; button.style.cssText = 'color:inherit;text-decoration:underline;margin-left:16px;padding:0';
      button.addEventListener('click', () => { undo(); node.hidden = true; }, {once:true}); node.append(button);
    }
    node.hidden = false; toastTimer = setTimeout(() => { node.hidden = true; }, undo ? 7000 : 3500);
  }

  /* Native dialogs trap focus, close with Escape, and restore the opener. */
  const dialogOpeners = new WeakMap();
  function openDialog(dialog, opener = document.activeElement, keepParent = false) {
    if (!dialog || dialog.open) return;
    if (!keepParent) $$('dialog[open]').forEach(other => other.close());
    closeSearch(false); closeMenus();
    dialogOpeners.set(dialog, opener);
    dialog.showModal(); document.body.classList.add('ss-modal-open');
  }
  function closeDialog(dialog) { if (dialog?.open) dialog.close(); }
  function bindDialogs() { $$('dialog').forEach(dialog => {
    if (dialog.dataset.ssBound) return;
    dialog.dataset.ssBound = 'true';
    dialog.addEventListener('click', event => { if (event.target !== dialog) return; const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('ss-modal-open');
      const opener = dialogOpeners.get(dialog); if (opener?.isConnected && !opener.closest('dialog:not([open])')) opener.focus({preventScroll:true});
      if (dialog.id === 'ssQuickView') quickController?.abort();
    });
  }); }
  bindDialogs();

  /* A single shared wishlist. Legacy IDs are retained and resolved lazily. */
  const WISH_KEY = 'ss:wishlist:v3';
  function normalizeList(list) {
    if (!Array.isArray(list)) return [];
    const unique = new Map();
    list.forEach(item => {
      const id = String(typeof item === 'object' && item ? item.id : item);
      if (!/^\d+$/.test(id)) return;
      const handle = typeof item?.handle === 'string' ? item.handle : '';
      unique.set(id, {id, handle:handle || unique.get(id)?.handle || ''});
    });
    return Array.from(unique.values());
  }
  let wishlist = normalizeList(parse(storage.get(WISH_KEY), null) || [...(Array.isArray(parse(storage.get('vl_wishlist'))) ? parse(storage.get('vl_wishlist')) : []), ...(Array.isArray(parse(storage.get('stylesteals-wishlist'))) ? parse(storage.get('stylesteals-wishlist')) : [])]);
  storage.set(WISH_KEY, wishlist);
  function freshWishlist() { const stored = storage.get(WISH_KEY); if (stored !== null) wishlist = normalizeList(parse(stored)); return wishlist; }
  function saveWishlist(list, announce = true) {
    wishlist = normalizeList(list);
    if (!storage.set(WISH_KEY, wishlist) && announce) toast('Saved for this visit. Browser storage is unavailable.');
    syncWishlist(); document.dispatchEvent(new CustomEvent('ss:wishlist-change', {detail:{items:wishlist}}));
  }
  function syncWishlist() {
    let enriched = false;
    $$('[data-wish]').forEach(button => {
      const item = wishlist.find(entry => entry.id === button.dataset.wish);
      if (item && !item.handle && button.dataset.handle) { item.handle = button.dataset.handle; enriched = true; }
      button.setAttribute('aria-pressed', String(Boolean(item)));
      button.setAttribute('aria-label', item ? 'Remove from saved pieces' : 'Save this piece');
      const label = $('[data-save-label]', button); if (label) label.textContent = item ? 'Saved to your edit' : 'Save to your edit';
    });
    $$('[data-wishlist-count]').forEach(node => { node.textContent = wishlist.length; node.hidden = !wishlist.length; });
    if (enriched) storage.set(WISH_KEY, wishlist);
  }
  function toggleWish(button) {
    freshWishlist(); const id = button.dataset.wish;
    if (wishlist.some(item => item.id === id)) { saveWishlist(wishlist.filter(item => item.id !== id)); toast('Removed from your edit.'); }
    else { saveWishlist([...wishlist, {id, handle:button.dataset.handle || ''}]); toast('Saved to your edit.'); }
  }
  /* Dynamic saved and recent cards use the same Liquid card as catalog pages. */
  const cardCache = new Map();
  async function renderCard(handle) {
    if (!cardCache.has(handle)) cardCache.set(handle, (async () => {
      const url = new URL(productURL(handle),location.origin);
      url.searchParams.set('section_id','stylesteals-card-render');
      const html = await request(url);
      const card = $('[data-product-card]',new DOMParser().parseFromString(html,'text/html'));
      if (!card) throw new Error('Card unavailable');
      return card.outerHTML;
    })().catch(error => {cardCache.delete(handle); throw error;}));
    return cardCache.get(handle);
  }
  let wishRender = 0, resolvingLegacy = false;
  async function resolveLegacy() {
    if (resolvingLegacy || !wishlist.some(item => !item.handle)) return;
    resolvingLegacy = true;
    try {
      // The public catalog endpoint is used only to match old IDs to handles.
      // Prices always come from the locale-aware Ajax Product API in cents.
      for (let page = 1; wishlist.some(item => !item.handle); page++) {
        const result = await request(route(`products.json?limit=250&page=${page}`));
        if (!Array.isArray(result.products) || !result.products.length) break;
        freshWishlist(); let changed = false;
        result.products.forEach(p => { const item = wishlist.find(x => x.id === String(p.id)); if (item && !item.handle) { item.handle = p.handle; changed = true; } });
        if (changed) { storage.set(WISH_KEY, wishlist); syncWishlist(); await renderWishlist(false); }
        if (result.products.length < 250) break;
      }
    } catch { /* Keep unresolved legacy items; never silently erase them. */ }
    finally { resolvingLegacy = false; }
  }
  async function renderWishlist(resolve = true) {
    const grid = $('[data-wishlist-grid]'); if (!grid) return;
    const generation = ++wishRender, items = [...wishlist];
    const summary = $('[data-saved-summary]'), empty = $('[data-wishlist-empty]'), clear = $('[data-clear-wishlist]');
    summary.textContent = `${items.length} saved ${items.length === 1 ? 'piece' : 'pieces'}`;
    empty.hidden = Boolean(items.length); clear.hidden = !items.length; grid.innerHTML = '';
    const slots = items.map(item => { const slot = document.createElement('div'); slot.innerHTML = '<div class="ss-skeleton" aria-label="Loading saved piece"></div>'; grid.append(slot); return {item,slot}; });
    for (let start = 0; start < slots.length; start += 4) {
      await Promise.allSettled(slots.slice(start,start + 4).map(async ({item,slot}) => {
        try {
          if (!item.handle) throw new Error('legacy');
          const html = await renderCard(item.handle);
          if (generation !== wishRender) return;
          slot.outerHTML = html;
        } catch {
          if (generation !== wishRender) return;
          slot.className = 'ss-saved-unavailable';
          slot.innerHTML = `<p>${item.handle ? 'This saved piece could not be loaded. It may be unavailable, or the connection was interrupted.' : 'Restoring a piece saved in your previous theme…'}</p><button type="button" data-wish="${escape(item.id)}" data-handle="${escape(item.handle)}" aria-pressed="true">Remove saved item</button>${item.handle ? `<a class="ss-text-link" href="${escape(productURL(item.handle))}">View product</a>` : ''}`;
        }
      }));
      if (generation !== wishRender) return;
    }
    syncWishlist(); if (resolve) await resolveLegacy();
    if (generation === wishRender) $$('[data-wishlist-grid] .ss-saved-unavailable').forEach(slot => { if (slot.textContent.includes('Restoring')) $('p',slot).textContent = 'This older saved piece is not currently available. It has been kept in your edit.'; });
  }
  document.addEventListener('ss:wishlist-change', () => renderWishlist());
  window.addEventListener('storage', event => { if (event.key === WISH_KEY || event.key === null) { freshWishlist(); syncWishlist(); renderWishlist(); } });

  /* Option values are resolved by Shopify, including high-variant products. */
  const optionRequests = new WeakMap();
  async function chooseOption(input) {
    const scope = input.closest('[data-product-scope]'); if (!scope) return;
    const otherProduct = input.dataset.optionProductUrl;
    if (otherProduct && sameOriginURL(otherProduct).pathname !== sameOriginURL(scope.dataset.productUrl).pathname) { location.assign(otherProduct); return; }
    optionRequests.get(scope)?.abort(); const controller = new AbortController(); optionRequests.set(scope,controller);
    const values = $$('[data-option-value-id]:checked',scope).map(el => el.dataset.optionValueId);
    const url = sameOriginURL(scope.dataset.productUrl); url.searchParams.set('option_values',values.join(',')); url.searchParams.set('section_id',scope.dataset.sectionId);
    const quantity = $('[name=quantity]',scope)?.value || '1';
    const oldPlan = $('[name=selling_plan]',scope)?.value;
    const selectedInputID = input.id;
    scope.setAttribute('aria-busy','true'); $$('[data-add-button]',scope).forEach(button => { button.disabled = true; });
    const error = $('[data-form-error]',scope); if (error) error.hidden = true;
    try {
      const html = await request(url, {signal:controller.signal});
      const doc = new DOMParser().parseFromString(html,'text/html');
      const next = $('[data-product-scope]',doc); if (!next) throw new Error('Options could not be loaded. Please try another selection.');
      if (!scope.isConnected || optionRequests.get(scope) !== controller) return;
      const nextQuantity = $('[name=quantity]',next);
      if (nextQuantity) nextQuantity.value = clampQuantity(nextQuantity,Number(quantity));
      if (oldPlan && $$('[name=selling_plan] option',next).some(option => option.value === oldPlan)) $('[name=selling_plan]',next).value = oldPlan;
      const quick = Boolean(scope.closest('#ssQuickView'));
      scope.replaceWith(next); updatePlan(next);
      document.getElementById(selectedInputID)?.focus({preventScroll:true});
      updateGalleryForVariant(next, next);
      if (quick) {
        const details = $('.ss-view-details',next);
        if (details && !next.dataset.selectedVariant) { const detailURL = sameOriginURL(next.dataset.productUrl); detailURL.searchParams.set('option_values',values.join(',')); details.href = detailURL.href; }
      }
      if (!quick) {
        const pageURL = new URL(location.href); pageURL.searchParams.delete('option_values');
        if (next.dataset.selectedVariant) pageURL.searchParams.set('variant',next.dataset.selectedVariant);
        else { pageURL.searchParams.delete('variant'); pageURL.searchParams.set('option_values',values.join(',')); }
        history.replaceState({},'',pageURL);
        const sticky = $('[data-sticky-price]'); if (sticky) sticky.textContent = $('[data-selected-price]',next).textContent;
      }
      syncWishlist();
    } catch (err) {
      if (err.name === 'AbortError') return;
      // A stale variant must never be submitted after a selection fails.
      if (error) { error.textContent = err.message + ' Reselect an option to retry.'; error.hidden = false; }
      scope.removeAttribute('aria-busy');
    }
  }
  function updatePlan(scope) {
    const select = $('[data-selling-plan]',scope), price = $('[data-selected-price]',scope);
    if (select && price) price.textContent = money(select.selectedOptions[0]?.dataset.price || price.dataset.basePrice);
  }
  let quickController;
  async function quickShop(trigger) {
    const dialog = $('#ssQuickView'), content = $('[data-quick-content]',dialog);
    if (!dialog || !content) return;
    quickController?.abort(); openDialog(dialog,trigger); quickController = new AbortController();
    content.innerHTML = '<div class="ss-quick-loading"><span class="ss-spinner"></span><p>Finding your piece…</p></div>';
    try {
      const card = trigger.closest('[data-product-card]');
      const url = sameOriginURL(card?.dataset.productUrl || productURL(trigger.dataset.quick)); url.searchParams.set('section_id','stylesteals-quick-product');
      const html = await request(url, {signal:quickController.signal});
      const doc = new DOMParser().parseFromString(html,'text/html'), layout = $('.ss-quick-layout',doc);
      if (!layout) throw new Error('Quick shop is unavailable for this piece.');
      content.replaceChildren(layout); syncWishlist(); updatePlan(layout);
      const colorID = $('[data-card-color][aria-pressed=true]',card)?.dataset.optionValueId;
      if (colorID) {
        const option = $$('[data-option-value-id]',layout).find(el => el.dataset.optionValueId === colorID);
        if (option && !option.checked) { option.checked = true; await chooseOption(option); }
      }
    } catch (error) {
      if (error.name === 'AbortError') return;
      content.innerHTML = `<div class="ss-quick-loading"><p>${escape(error.message)}</p><a class="ss-btn ss-btn-dark" href="${escape(productURL(trigger.dataset.quick))}">Open product details</a></div>`;
    }
  }
  const colorRequests = new WeakMap();
  function applyCardColor(card, button) {
    $$('[data-card-color]',card).forEach(dot => dot.setAttribute('aria-pressed',String(dot === button)));
    const url = sameOriginURL(card.dataset.productUrl);
    url.searchParams.delete('variant');
    url.searchParams.set('option_values',button.dataset.optionValueId);
    $$('a.ss-card-photo,a.ss-card-title',card).forEach(link => { link.href = url.href; });
    const quick = $('[data-quick]',card); if (quick) quick.dataset.quick = card.dataset.productHandle;
    card.dataset.selectedColorId = button.dataset.optionValueId;
    const price = $('[data-card-price]',card);
    if (price) {
      const rangeMin = button.dataset.previewRangeMin;
      const rangeMax = button.dataset.previewRangeMax;
      const selectedPrice = button.dataset.previewPrice;
      if (rangeMin && rangeMax) {
        const label = rangeMin === rangeMax ? `${button.title} ${rangeMin}` : colorLabel(labels.colorRange || '__COLOR__ range __MIN__–__MAX__',button.title,rangeMin,rangeMax);
        price.replaceChildren();
        const amount = document.createElement('span');
        amount.textContent = label;
        price.append(amount);
        price.setAttribute('aria-label',`${label}; size may change the price`);
      } else if (selectedPrice && button.dataset.previewVariant) {
        price.replaceChildren();
        const amount = document.createElement('span');
        amount.textContent = `${labels.selectedOptions || 'Selected options'} ${selectedPrice}`;
        price.append(amount);
        if (button.dataset.previewCompare) {
          const compare = document.createElement('s');
          compare.textContent = button.dataset.previewCompare;
          price.append(compare);
        }
        price.setAttribute('aria-label',`${labels.selectedOptions || 'Selected options'} ${selectedPrice}; changing size may change the price`);
      } else {
        price.replaceChildren();
        price.textContent = labels.chooseOptionsPrice || 'Choose options for price';
        price.setAttribute('aria-label','Choose options to see the price');
      }
    }
    let availability = $('.ss-card-status',card);
    if (button.dataset.previewAvailable === 'false') {
      if (!availability) { availability = document.createElement('span'); availability.className = 'ss-card-status'; $('.ss-card-detail-row',card)?.append(availability); }
      availability.classList.remove('ss-card-sale'); availability.textContent = labels.unavailableOptions || 'Unavailable with current options'; availability.hidden = false;
    } else if (availability && card.dataset.productAvailable === 'true') availability.hidden = true;
    const image = $('.ss-card-primary',card), src = safeURL(button.dataset.previewImage);
    let status = $('[data-card-preview-status]',card);
    if (!status) { status = document.createElement('span'); status.dataset.cardPreviewStatus = ''; status.className = 'ss-card-preview-status'; status.setAttribute('role','status'); $('.ss-card-detail-row',card)?.append(status); }
    status.textContent = src ? colorLabel(labels.showingColor || 'Showing __COLOR__',button.title) : colorLabel(labels.imageUnavailable || '__COLOR__: image unavailable',button.title);
    if (src && image) {
      image.src = src; image.width = Number(button.dataset.previewWidth) || image.width; image.height = Number(button.dataset.previewHeight) || image.height;
      const source = new URL(src);
      if (source.hostname.endsWith('cdn.shopify.com') || source.pathname.startsWith('/cdn/shop/')) {
        const max = Math.min(Number(button.dataset.previewWidth) || 1100,1100);
        image.srcset = [...[240,360,540,750].filter(width => width < max),max].map(width => { const url = new URL(src); url.searchParams.set('width',width); return `${url.href} ${width}w`; }).join(', ');
      } else image.removeAttribute('srcset');
    }
    card.classList.add('ss-color-selected');
  }
  async function selectCardColor(button) {
    const card = button.closest('[data-product-card]'); if (!card) return;
    colorRequests.get(card)?.abort();
    const other = button.dataset.optionProductUrl;
    if (other && sameOriginURL(other).pathname !== sameOriginURL(card.dataset.productUrl).pathname) {
      const controller = new AbortController(); colorRequests.set(card,controller);
      button.setAttribute('aria-busy','true');
      try {
        const url = sameOriginURL(other); url.searchParams.set('section_id','stylesteals-card-render');
        const html = await request(url,{signal:controller.signal});
        if (colorRequests.get(card) !== controller || !card.isConnected) return;
        const fresh = $('[data-product-card]',new DOMParser().parseFromString(html,'text/html'));
        if (!fresh) throw new Error('Color preview unavailable.');
        card.replaceWith(fresh); syncWishlist();
        const dot = $$('[data-card-color]',fresh).find(el => el.title === button.title);
        if (dot) { applyCardColor(fresh,dot); dot.focus({preventScroll:true}); }
        else { const label = document.createElement('span'); label.className = 'ss-card-preview-status'; label.textContent = `Showing ${button.title}`; $('.ss-card-detail-row',fresh)?.append(label); $('.ss-card-title',fresh)?.focus({preventScroll:true}); }
      } catch(error) { if (error.name !== 'AbortError') toast(error.message); }
      finally { button.removeAttribute('aria-busy'); }
    } else applyCardColor(card,button);
  }
  function convertFit(button) {
    const panel = button.closest('[data-size-fit]'), table = $('table[data-source-unit]',panel); if (!table) return;
    const target = button.dataset.fitUnit, source = table.dataset.sourceUnit;
    $$('[data-fit-unit]',panel).forEach(el => el.setAttribute('aria-pressed',String(el === button)));
    $$('[data-source-value]',table).forEach(cell => {
      const raw = cell.dataset.sourceValue, value = Number(raw);
      if (!raw || !Number.isFinite(value)) { cell.textContent = raw; return; }
      const converted = source === target ? raw : (source === 'cm' ? value / 2.54 : value * 2.54).toFixed(1).replace(/\.0$/,'');
      cell.textContent = converted;
    });
  }
  const lookRequests = new WeakMap();
  function lookState(section) {
    const selected = $$('[data-look-item]',section).filter(item => $('[data-look-include]',item)?.checked);
    const rows = selected.map(item => {
      const quantity = $('[data-look-quantity]',item), plan = $('[data-look-plan]',item);
      const count = Number(quantity?.value), min = Number(item.dataset.min || 1), step = Number(item.dataset.step || 1), max = item.dataset.max ? Number(item.dataset.max) : Infinity;
      const price = plan?.selectedOptions[0]?.dataset.price || item.dataset.price;
      const valid = item.dataset.available === 'true' && /^\d+$/.test(item.dataset.variantId || '') && Number.isInteger(count) && count >= min && count <= max && (count-min)%step === 0 && (!plan || plan.checkValidity()) && (item.dataset.requiresPlan !== 'true' || Boolean(plan?.value));
      const amount = $('[data-look-price]',item); if (amount && Number.isFinite(Number(price))) amount.textContent = money(price);
      return {item,id:Number(item.dataset.variantId),quantity:count,price:Number(price),plan:plan?.value,valid};
    });
    const valid = rows.length > 0 && !$('[data-look-item][aria-busy]',section) && rows.every(row => row.valid && Number.isFinite(row.price));
    $('[data-look-subtotal]',section).textContent = money(rows.reduce((sum,row) => sum + (row.valid && Number.isFinite(row.price) ? row.price * row.quantity : 0),0));
    $('[data-look-add]',section).disabled = !valid || section.dataset.lookBusy === 'true' || section.dataset.lookReview === 'true';
    return {rows,valid};
  }
  async function chooseLookOption(select) {
    const old = select.closest('[data-look-item]'), section = select.closest('[data-complete-look]');
    lookRequests.get(old)?.abort(); const controller = new AbortController(); lookRequests.set(old,controller);
    const inputs = $$('[data-look-option]',old), index = inputs.indexOf(select), ids = inputs.map(input => input.value);
    const other = select.selectedOptions[0]?.dataset.productUrl;
    const url = sameOriginURL(other || old.dataset.productUrl); url.searchParams.set('option_values',ids.join(',')); url.searchParams.set('section_id','stylesteals-look-item');
    const included = $('[data-look-include]',old).checked, quantity = $('[data-look-quantity]',old).value, plan = $('[data-look-plan]',old)?.value;
    old.setAttribute('aria-busy','true'); section.dataset.lookBusy = 'true'; lookState(section);
    try {
      const html = await request(url,{signal:controller.signal});
      if (!old.isConnected || lookRequests.get(old) !== controller) return;
      const fresh = $('[data-look-item]',new DOMParser().parseFromString(html,'text/html'));
      if (!fresh) throw new Error('Options could not be loaded.');
      const check = $('[data-look-include]',fresh); check.checked = included && !check.disabled;
      const qty = $('[data-look-quantity]',fresh); qty.value = quantity;
      const freshPlan = $('[data-look-plan]',fresh); if (freshPlan && plan && $$('option',freshPlan).some(o => o.value === plan)) freshPlan.value = plan;
      old.replaceWith(fresh); $$('[data-look-option]',fresh)[index]?.focus({preventScroll:true});
      const error = $('[data-look-error]',section); error.hidden = true;
    } catch(error) { if (error.name !== 'AbortError') { const message = $('[data-look-error]',section); message.textContent = error.message; message.hidden = false; } old.removeAttribute('aria-busy'); }
    finally { section.dataset.lookBusy = 'false'; lookState(section); }
  }
  async function addLook(section) {
    const state = lookState(section); if (!state.valid) return;
    const button = $('[data-look-add]',section), error = $('[data-look-error]',section);
    section.dataset.lookBusy = 'true'; lookState(section); error.hidden = true;
    const items = state.rows.map(row => ({id:row.id,quantity:row.quantity,...(row.plan ? {selling_plan:Number(row.plan)} : {})}));
    try {
      await queueCart(async () => {
        const before = await request(route('cart.js'));
        try {
          const result = await request((config.add || route('cart/add')) + '.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items,sections:['stylesteals-cart_drawer'],sections_url:location.pathname})});
          await refreshCart(result.sections);
          $$('[data-look-include]:checked',section).forEach(check => {check.checked = false;});
          openDialog($('#ssCart'),button); cartError('');
        } catch (failure) {
          try {
            const after = await refreshCart();
            const count = (cart,id) => cart.items.filter(line => line.variant_id === id).reduce((sum,line) => sum + line.quantity,0);
            const changed = items.some(item => count(after,item.id) > count(before,item.id));
            if (changed) { section.dataset.lookReview = 'true'; error.textContent = 'Your bag changed. Review it before selecting items again.'; openDialog($('#ssCart'),button); }
            else error.textContent = failure.message;
          } catch { section.dataset.lookReview = 'true'; error.textContent = 'Your bag could not be verified. Open the bag page before trying again.'; }
          error.hidden = false;
        }
      });
    } catch(failure) { error.textContent = failure.message; error.hidden = false; }
    finally { section.dataset.lookBusy = 'false'; lookState(section); }
  }
  /* Gallery state is scoped to its product, including quick shop. */
  let activeGallery = null, suppressGalleryClickUntil = 0, suppressZoomClickUntil = 0;
  const galleryButtons = gallery => gallery ? $$('[data-gallery-src]', gallery) : [];
  function selectGalleryImage(gallery, index, focus = false) {
    const buttons = galleryButtons(gallery); if (!buttons.length) return;
    index = (index + buttons.length) % buttons.length;
    const button = buttons[index], image = $('[data-gallery-main]', gallery);
    gallery.dataset.galleryIndex = String(index);
    if (image) {
      image.src = button.dataset.gallerySrc;
      image.srcset = button.dataset.gallerySrcset || '';
      image.alt = button.dataset.galleryAlt || gallery.dataset.productTitle;
      image.width = Number(button.dataset.imageWidth); image.height = Number(button.dataset.imageHeight);
      image.closest('[data-zoom-src]').dataset.zoomSrc = button.dataset.galleryZoom;
    }
    buttons.forEach((thumb, i) => { thumb.setAttribute('aria-pressed', String(i === index)); thumb.tabIndex = i === index ? 0 : -1; });
    $('[data-gallery-counter]', gallery).textContent = `${index + 1} / ${buttons.length}`;
    $('[data-gallery-caption]', gallery).textContent = button.dataset.galleryAlt || gallery.dataset.productTitle;
    const rail = button.parentElement;
    if (rail.scrollHeight > rail.clientHeight + 2) rail.scrollTop = button.offsetTop - rail.offsetTop - rail.clientHeight / 2 + button.offsetHeight / 2;
    if (rail.scrollWidth > rail.clientWidth + 2) rail.scrollLeft = button.offsetLeft - rail.offsetLeft - rail.clientWidth / 2 + button.offsetWidth / 2;
    if (focus) button.focus({preventScroll:true});
    if (activeGallery === gallery && $('#ssZoom')?.open) renderZoom();
  }
  function stepGallery(gallery, direction) { selectGalleryImage(gallery, Number(gallery?.dataset.galleryIndex || 0) + direction); }
  function updateGalleryForVariant(scope, next) {
    const container = scope.closest('.ss-quick-layout') || scope.closest('[data-product-page]');
    const gallery = container && $('[data-product-gallery]', container);
    const index = galleryButtons(gallery).findIndex(button => button.dataset.imageId === next.dataset.selectedImageId);
    if (index >= 0) selectGalleryImage(gallery, index);
  }
  function setZoom(enlarged) {
    const viewport = $('[data-zoom-viewport]'); if (!viewport) return;
    viewport.classList.toggle('is-zoomed', enlarged);
    $$('[data-zoom-toggle]').forEach(button => { button.setAttribute('aria-pressed', String(enlarged)); button.setAttribute('aria-label', enlarged ? 'Zoom out' : 'Zoom in'); });
    $('[data-zoom-scale-label]').textContent = enlarged ? 'Zoom out' : 'Zoom in';
    viewport.scrollLeft = enlarged ? (viewport.scrollWidth - viewport.clientWidth) / 2 : 0;
    viewport.scrollTop = enlarged ? (viewport.scrollHeight - viewport.clientHeight) / 2 : 0;
  }
  function renderZoom() {
    const buttons = galleryButtons(activeGallery), index = Number(activeGallery?.dataset.galleryIndex || 0), button = buttons[index];
    if (!button) return;
    setZoom(false);
    const img = $('[data-zoom-image]');
    img.src = button.dataset.galleryZoom; img.alt = button.dataset.galleryAlt || activeGallery.dataset.productTitle;
    img.width = Number(button.dataset.imageWidth); img.height = Number(button.dataset.imageHeight);
    $('#ssZoomTitle').textContent = activeGallery.dataset.productTitle;
    $('[data-zoom-counter]').textContent = `${index + 1} / ${buttons.length}`;
    $('[data-zoom-caption]').textContent = img.alt;
    $$('[data-zoom-step]').forEach(control => { control.disabled = buttons.length < 2; });
  }
  function openGalleryZoom(gallery, opener) {
    if (!galleryButtons(gallery).length || Date.now() < suppressGalleryClickUntil) return;
    activeGallery = gallery; renderZoom(); openDialog($('#ssZoom'), opener, Boolean(opener.closest('#ssQuickView')));
  }
  let galleryTouch = null, zoomDrag = null;
  document.addEventListener('pointerdown', event => {
    const viewport = event.target.closest('[data-gallery-swipe]');
    if (viewport && event.pointerType !== 'mouse') galleryTouch = {gallery:viewport.closest('[data-product-gallery]'),x:event.clientX,y:event.clientY,id:event.pointerId};
    const zoom = event.target.closest('[data-zoom-viewport].is-zoomed');
    if (zoom && event.pointerType === 'mouse' && event.button === 0) {
      zoomDrag = {viewport:zoom,x:event.clientX,y:event.clientY,left:zoom.scrollLeft,top:zoom.scrollTop,id:event.pointerId,moved:false};
      event.target.setPointerCapture?.(event.pointerId);
    }
  });
  document.addEventListener('pointermove', event => {
    if (!zoomDrag || zoomDrag.id !== event.pointerId) return;
    const dx = event.clientX - zoomDrag.x, dy = event.clientY - zoomDrag.y;
    if (Math.abs(dx) + Math.abs(dy) > 6) { zoomDrag.moved = true; zoomDrag.viewport.classList.add('is-dragging'); }
    if (zoomDrag.moved) { zoomDrag.viewport.scrollLeft = zoomDrag.left - dx; zoomDrag.viewport.scrollTop = zoomDrag.top - dy; event.preventDefault(); }
  });
  document.addEventListener('pointerup', event => {
    if (galleryTouch?.id === event.pointerId) {
      const dx = event.clientX - galleryTouch.x, dy = event.clientY - galleryTouch.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) { stepGallery(galleryTouch.gallery, dx < 0 ? 1 : -1); suppressGalleryClickUntil = Date.now() + 400; }
      galleryTouch = null;
    }
    if (zoomDrag?.id === event.pointerId) { if (zoomDrag.moved) suppressZoomClickUntil = Date.now() + 400; zoomDrag.viewport.classList.remove('is-dragging'); zoomDrag = null; }
  });
  document.addEventListener('pointercancel', () => { galleryTouch = null; zoomDrag?.viewport.classList.remove('is-dragging'); zoomDrag = null; });
  function clampQuantity(input, value) {
    const min = Number(input.min || 1), max = input.max ? Number(input.max) : Infinity, step = Number(input.step || 1);
    return Math.max(min,Math.min(max,min + Math.round((Number(value || min) - min)/step)*step));
  }

  /* AJAX cart mutations are serialized; checkout remains a native Shopify form. */
  let cartQueue = Promise.resolve(), cartTasks = 0;
  function queueCart(task) {
    cartTasks++;
    $$('button[name=checkout]').forEach(button => { button.disabled = true; });
    cartQueue = cartQueue.catch(() => {}).then(task).finally(() => {
      cartTasks--; if (!cartTasks) $$('button[name=checkout]').forEach(button => { button.disabled = false; });
    });
    return cartQueue;
  }
  function cartError(message) { $$('[data-cart-error]').forEach(node => { node.textContent = message; node.hidden = !message; }); }
  function renderCartSections(html) {
    const doc = new DOMParser().parseFromString(html,'text/html');
    ['[data-cart-lines]','[data-cart-summary]'].forEach(selector => {
      const fresh = $(selector,doc); if (fresh) $$(selector).forEach(old => old.replaceWith(fresh.cloneNode(true)));
    });
    if (cartTasks) $$('button[name=checkout]').forEach(button => { button.disabled = true; });
  }
  async function refreshCart(sections) {
    const cart = await request(route('cart.js'));
    $$('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; node.hidden = !cart.item_count && node.classList.contains('ss-count'); });
    let html = sections?.['stylesteals-cart_drawer'];
    if (!html) html = await request(route('?section_id=stylesteals-cart_drawer'));
    renderCartSections(html); document.dispatchEvent(new CustomEvent('ss:cart-updated',{detail:{cart}})); return cart;
  }
  async function openCart(opener) {
    openDialog($('#ssCart'),opener); cartError('');
    try { await queueCart(() => refreshCart()); } catch { cartError('Your bag could not refresh. Try again, or open the bag page.'); }
  }
  async function addToCart(form) {
    if (!form.reportValidity()) return;
    const button = $('[data-add-button]',form); if (!button || button.disabled) return;
    const data = new FormData(form); data.set('sections','stylesteals-cart_drawer'); data.set('sections_url',location.pathname);
    const label = button.innerHTML, error = $('[data-form-error]',form); button.disabled = true; button.textContent = 'Adding…'; if (error) error.hidden = true;
    try {
      await queueCart(async () => {
        const added = await request((config.add || route('cart/add')) + '.js',{method:'POST',body:data});
        openDialog($('#ssCart'),document.querySelector('[data-open-cart]'));
        cartError('');
        try { await refreshCart(added.sections); } catch { cartError('Your item was added. Open the bag page to review it.'); }
      });
    } catch (err) { if (error) { error.textContent = err.message; error.hidden = false; } }
    finally { if (button.isConnected) { button.disabled = false; button.innerHTML = label; } }
  }
  async function changeCart(key, quantity, source) {
    if (!Number.isInteger(quantity) || quantity < 0) return;
    const line = source?.closest('[data-cart-line]');
    if (line) { line.setAttribute('aria-busy','true'); $$('button,input',line).forEach(node => { node.disabled = true; }); }
    cartError('');
    try {
      await queueCart(async () => {
        const cart = await request((config.change || route('cart/change')) + '.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity,sections:['stylesteals-cart_drawer'],sections_url:location.pathname})});
        await refreshCart(cart.sections);
      });
    } catch (err) { cartError(err.message); try { await refreshCart(); } catch {} }
    finally { if (line?.isConnected) { line.removeAttribute('aria-busy'); $$('button,input',line).forEach(node => { node.disabled = false; }); } }
  }

  /* Facets and sort always request a new Shopify result set, never filter DOM cards. */
  let catalogController;
  function setDensity(value) {
    value = value === 'comfortable' ? 'comfortable' : 'compact';
    $$('[data-catalog]').forEach(catalog => { catalog.dataset.density = value; $$('[data-density][type=button]',catalog).forEach(button => button.setAttribute('aria-pressed',String(button.dataset.density === value))); });
    storage.set('ss:density',value);
  }
  async function updateCatalog(target, push = true) {
    const catalog = $('[data-catalog]'); if (!catalog) { location.assign(target); return; }
    const url = sameOriginURL(target), requestURL = new URL(url); requestURL.searchParams.set('section_id',catalog.dataset.sectionId);
    catalogController?.abort(); const controller = new AbortController(); catalogController = controller;
    const filterOpen = !$('[id^=facets-]',catalog)?.hidden;
    catalog.setAttribute('aria-busy','true');
    try {
      const html = await request(requestURL,{signal:controller.signal});
      const next = $('[data-catalog]',new DOMParser().parseFromString(html,'text/html')); if (!next) throw new Error('Results could not be loaded.');
      catalog.replaceWith(next); setDensity(parse(storage.get('ss:density'),'compact')); syncWishlist();
      if (filterOpen) { const panel = $('[id^=facets-]',next); if (panel) panel.hidden = false; $('[data-filter-toggle]',next)?.setAttribute('aria-expanded','true'); }
      if (push) history.pushState({ssCatalog:true},'',url);
      const toolbar = $('.ss-catalog-toolbar',next); if (toolbar) { toolbar.setAttribute('tabindex','-1'); toolbar.focus({preventScroll:true}); toolbar.scrollIntoView({block:'start',behavior:'auto'}); }
    } catch (err) {
      if (err.name === 'AbortError') return;
      const error = $('[data-catalog-error]',catalog); if (error) { error.hidden = false; error.innerHTML = 'Results could not refresh. <a href="' + escape(url.href) + '">Reload these results</a>.'; }
    } finally { catalog.removeAttribute('aria-busy'); }
  }
  function submitFacets(form) {
    const min = $('input[name$=".gte"]',form), max = $('input[name$=".lte"]',form);
    if (max) max.setCustomValidity(min?.value && max.value && Number(min.value) > Number(max.value) ? 'Maximum price must be at least the minimum price.' : '');
    if (!form.reportValidity()) return;
    const url = sameOriginURL(form.action); const params = new URLSearchParams(new FormData(form));
    for (const key of Array.from(params.keys())) if (!params.get(key)) params.delete(key);
    params.delete('page'); url.search = params.toString(); updateCatalog(url);
  }
  window.addEventListener('popstate',() => { if ($('[data-catalog]')) updateCatalog(location.href,false); });

  /* Search is abortable and keyboard navigable. Price is fetched in cents when selected. */
  let searchInput = $('#ssSearchInput'), searchPanel = $('#ssSearchPanel'), searchResults = $('#ssSearchResults');
  let searchController, searchTimer, searchSequence = 0;
  function closeMenus(except) { $$('.ss-nav-details[open]').forEach(details => { if (details !== except) details.open = false; }); }
  function closeSearch(restore = true) {
    if (!searchPanel || searchPanel.hidden) return;
    searchPanel.hidden = true; $$('[data-search-toggle]').forEach(button => button.setAttribute('aria-expanded','false'));
    searchInput?.setAttribute('aria-expanded','false');
    searchInput?.removeAttribute('aria-activedescendant');
    searchController?.abort(); clearTimeout(searchTimer); searchSequence++;
    if (restore) $('[data-search-toggle]')?.focus();
  }
  function openSearch() {
    closeMenus(); searchPanel.hidden = false;
    $$('[data-search-toggle]').forEach(button => button.setAttribute('aria-expanded','true')); searchInput.focus();
  }
  async function predictiveSearch(term) {
    searchController?.abort(); searchController = new AbortController(); const sequence = ++searchSequence;
    if (term.length < 2) { searchResults.innerHTML = ''; searchInput.setAttribute('aria-expanded','false'); return; }
    const url = sameOriginURL((config.predictive || route('search/suggest')) + '.json');
    url.search = new URLSearchParams({q:term,'resources[type]':'product,collection,query','resources[limit]':'4','resources[limit_scope]':'each','resources[options][unavailable_products]':'last'}).toString();
    searchResults.setAttribute('aria-busy','true'); searchInput.removeAttribute('aria-activedescendant');
    try {
      const data = await request(url,{signal:searchController.signal});
      if (sequence !== searchSequence) return;
      const results = data.resources?.results || {}, items = [...(results.products || []), ...(results.collections || []), ...(results.queries || [])].slice(0,8);
      searchResults.innerHTML = items.map((item,index) => {
        const href = safeURL(item.url || `${config.search || route('search')}?type=product&q=${encodeURIComponent(item.text || item.title)}`);
        const image = safeURL(item.featured_image?.url || item.image?.url || item.image || '');
        return `<a id="ssSuggestion-${index}" class="ss-search-result" href="${escape(href)}" role="option" aria-selected="false">${image && (item.featured_image || item.image) ? `<img src="${escape(image)}" width="64" height="80" alt="">` : ''}<span><strong>${escape(item.title || item.text)}</strong><small>${escape(item.type || item.product_type || (item.text ? 'Suggested search' : 'Explore'))}</small></span></a>`;
      }).join('') + `<a class="ss-text-link ss-search-all" href="${escape(config.search || route('search'))}?type=product&q=${encodeURIComponent(term)}">${items.length ? 'View all results' : 'Search all products'} for “${escape(term)}” →</a>`;
      searchInput.setAttribute('aria-expanded',String(items.length > 0)); $('[data-search-status]').textContent = `${items.length} suggestions available.`;
    } catch (err) {
      if (err.name === 'AbortError') return;
      searchResults.innerHTML = `<p class="ss-search-empty">Press Enter to search the full catalog.</p>`; searchInput.setAttribute('aria-expanded','false');
    } finally { if (sequence === searchSequence) searchResults.removeAttribute('aria-busy'); }
  }
  function bindSearch() {
  searchInput = $('#ssSearchInput'); searchPanel = $('#ssSearchPanel'); searchResults = $('#ssSearchResults');
  if (!searchInput || searchInput.dataset.ssBound) return;
  searchInput.dataset.ssBound = 'true';
  searchInput.addEventListener('input',() => { clearTimeout(searchTimer); searchController?.abort(); searchSequence++; const term = searchInput.value.trim(); if (term.length < 2) { searchResults.innerHTML=''; searchInput.setAttribute('aria-expanded','false'); searchInput.removeAttribute('aria-activedescendant'); return; } searchTimer = setTimeout(() => predictiveSearch(term),220); });
  searchInput?.addEventListener('keydown',event => {
    const options = $$('[role=option]',searchResults), index = options.findIndex(option => option.getAttribute('aria-selected') === 'true');
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      if (!options.length) return; event.preventDefault();
      const next = (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
      options.forEach((option,i) => option.setAttribute('aria-selected',String(i === next))); searchInput.setAttribute('aria-activedescendant',options[next].id); options[next].scrollIntoView({block:'nearest'});
    } else if (event.key === 'Enter' && index >= 0) { event.preventDefault(); location.assign(options[index].href); }
  });
  }
  bindSearch();
  document.addEventListener('toggle',event => { const details = event.target; if (details.matches('.ss-nav-details') && details.open) { closeMenus(details); closeSearch(false); } },true);

  function activateTab(tab) {
    const scope = tab.closest('[data-tabs]'); if (!scope) return;
    $$('[role=tab]',scope).forEach(button => { const active = button === tab; button.setAttribute('aria-selected',String(active)); button.tabIndex = active ? 0 : -1; });
    $$('[data-tab-panel]',scope).forEach(panel => { panel.hidden = panel.dataset.tabPanel !== tab.dataset.tab; });
    const panel = document.getElementById(tab.getAttribute('aria-controls'));
    if (panel?.dataset.tabLoad && !panel.dataset.loaded && !panel.dataset.loading) {
      panel.dataset.loading = 'true'; panel.setAttribute('aria-busy','true');
      request(panel.dataset.tabLoad).then(html => {
        const content = $('[data-edit-products]',new DOMParser().parseFromString(html,'text/html'));
        if (!content) throw new Error('The edit could not load.');
        $('.ss-grid',panel)?.replaceWith(content); panel.dataset.loaded = 'true'; syncWishlist();
      }).catch(() => {
        const grid = $('.ss-grid',panel); if (grid) grid.innerHTML = '<p class="ss-saved-status">This edit could not refresh. Use the link below to browse the full collection.</p>';
      }).finally(() => { delete panel.dataset.loading; panel.removeAttribute('aria-busy'); });
    }
  }
  document.addEventListener('keydown',event => {
    if (event.key === 'Escape') { closeSearch(); const menu = $('.ss-nav-details[open]'); if (menu) { menu.open = false; $('summary',menu)?.focus(); } }
    if ($('#ssZoom')?.open && ['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
      event.preventDefault(); const count = galleryButtons(activeGallery).length;
      if (event.key === 'Home' || event.key === 'End') selectGalleryImage(activeGallery,event.key === 'Home' ? 0 : count - 1);
      else stepGallery(activeGallery,event.key === 'ArrowRight' ? 1 : -1);
      return;
    }
    const thumb = event.target.closest('[data-gallery-src]');
    if (thumb && ['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) {
      event.preventDefault(); const gallery = thumb.closest('[data-product-gallery]'), buttons = galleryButtons(gallery), current = buttons.indexOf(thumb);
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : current + (['ArrowRight','ArrowDown'].includes(event.key) ? 1 : -1);
      selectGalleryImage(gallery,index,true); return;
    }
    const tab = event.target.closest('[role=tab]');
    if (tab && ['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
      event.preventDefault(); const tabs = $$('[role=tab]',tab.closest('[data-tabs]')), current = tabs.indexOf(tab);
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length-1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length)%tabs.length;
      activateTab(tabs[index]); tabs[index].focus();
    }
  });

  document.addEventListener('click',event => {
    const target = event.target;
    const opener = target.closest('[data-open-dialog]'); if (opener) { event.preventDefault(); openDialog(document.getElementById(opener.dataset.openDialog),opener); return; }
    if (target.closest('[data-close-dialog]')) { closeDialog(target.closest('dialog')); return; }
    const cart = target.closest('[data-open-cart]'); if (cart) { event.preventDefault(); openCart(cart); return; }
    const wish = target.closest('[data-wish]'); if (wish) { event.preventDefault(); toggleWish(wish); return; }
    const clear = target.closest('[data-clear-wishlist]'); if (clear) { const previous = [...freshWishlist()]; saveWishlist([]); toast('Your saved edit is clear.',() => saveWishlist([...freshWishlist(),...previous])); return; }
    const color = target.closest('[data-card-color]'); if (color) { event.preventDefault(); selectCardColor(color); return; }
    const unit = target.closest('[data-fit-unit]'); if (unit) { convertFit(unit); return; }
    const lookAdd = target.closest('[data-look-add]'); if (lookAdd) { addLook(lookAdd.closest('[data-complete-look]')); return; }
    const quick = target.closest('[data-quick]'); if (quick) { event.preventDefault(); quickShop(quick); return; }
    const quantity = target.closest('[data-quantity-step]'); if (quantity) {
      const input = $('input',quantity.closest('.ss-quantity')); if (!input || input.disabled) return;
      const previous = Number(input.value), next = clampQuantity(input,previous + Number(quantity.dataset.quantityStep)*Number(input.step || 1));
      input.value = next; if (next !== previous && input.hasAttribute('data-cart-quantity')) input.dispatchEvent(new Event('change',{bubbles:true})); return;
    }
    const remove = target.closest('[data-cart-remove]'); if (remove) { event.preventDefault(); changeCart(remove.dataset.cartRemove,0,remove); return; }
    const tab = target.closest('[role=tab][data-tab]'); if (tab) { activateTab(tab); return; }
    const density = target.closest('button[data-density]'); if (density) { setDensity(density.dataset.density); return; }
    const filter = target.closest('[data-filter-toggle]'); if (filter) { const panel = document.getElementById(filter.getAttribute('aria-controls')); panel.hidden = !panel.hidden; filter.setAttribute('aria-expanded',String(!panel.hidden)); return; }
    const catalogLink = target.closest('[data-catalog-link]'); if (catalogLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) { event.preventDefault(); updateCatalog(catalogLink.href); return; }
    const thumb = target.closest('[data-gallery-src]'); if (thumb) { const gallery = thumb.closest('[data-product-gallery]'); selectGalleryImage(gallery, galleryButtons(gallery).indexOf(thumb)); return; }
    const galleryStep = target.closest('[data-gallery-step]'); if (galleryStep) { stepGallery(galleryStep.closest('[data-product-gallery]'), Number(galleryStep.dataset.galleryStep)); return; }
    const zoom = target.closest('[data-zoom-src], [data-gallery-enlarge]'); if (zoom) { openGalleryZoom(zoom.closest('[data-product-gallery]'), zoom); return; }
    const zoomStep = target.closest('[data-zoom-step]'); if (zoomStep) { stepGallery(activeGallery, Number(zoomStep.dataset.zoomStep)); return; }
    if (target.closest('[data-zoom-toggle]')) { if (Date.now() >= suppressZoomClickUntil) setZoom(!$('[data-zoom-viewport]').classList.contains('is-zoomed')); return; }
    if (target.closest('[data-scroll-options]')) { const scope = $('[data-product-page] [data-product-scope]'); scope?.scrollIntoView({block:'center',behavior:'smooth'}); $('input,button',scope)?.focus({preventScroll:true}); return; }
    if (target.closest('[data-search-toggle]')) { searchPanel.hidden ? openSearch() : closeSearch(); return; }
    if (target.closest('[data-search-close]')) { closeSearch(); return; }
    if (!target.closest('.ss-site-header')) { closeMenus(); closeSearch(false); }
  });
  document.addEventListener('submit',event => {
    const form = event.target;
    if (form.matches('[data-product-form]')) { event.preventDefault(); addToCart(form); }
    else if (form.matches('[data-facets-form]')) { event.preventDefault(); submitFacets(form); }
  });
  document.addEventListener('change',event => {
    const input = event.target;
    if (input.matches('[data-option-value-id]')) chooseOption(input);
    if (input.matches('[data-look-option]')) chooseLookOption(input);
    if (input.matches('[data-look-include],[data-look-quantity],[data-look-plan]')) { const section = input.closest('[data-complete-look]'); section.dataset.lookReview = 'false'; lookState(section); }
    if (input.matches('[data-selling-plan]')) updatePlan(input.closest('[data-product-scope]'));
    if (input.matches('[data-sort]')) submitFacets(input.closest('form'));
    if (input.matches('[data-cart-quantity]')) { input.value = clampQuantity(input,Number(input.value)); changeCart(input.dataset.key,Number(input.value),input); }
  });
  document.addEventListener('input',event => { if (event.target.matches('[data-look-quantity]')) lookState(event.target.closest('[data-complete-look]')); });
  document.addEventListener('focusin',event => {
    const current = event.target.closest('.ss-nav-details'); if (!current) closeMenus();
  });

  async function recentlyViewed() {
    let recent = normalizeList(parse(storage.get('ss:recent:v3')));
    const current = $('[data-recent-product]');
    if (current) { const p = parse(current.textContent,{}); recent = normalizeList([p,...recent.filter(x => x.id !== String(p.id))]).slice(0,8); storage.set('ss:recent:v3',recent); }
    const section = $('[data-recent-section]'); if (!section || !recent.length) return;
    const items = await Promise.allSettled(recent.filter(p => p.handle).slice(0,4).map(p => renderCard(p.handle)));
    const cards = items.filter(x => x.status === 'fulfilled').map(x => x.value); if (!cards.length) return;
    $('[data-recent-grid]',section).innerHTML = cards.join(''); section.hidden = false; syncWishlist();
  }
  async function recommendations() {
    const el = $('[data-recommendations]'); if (!el || !el.hidden || !el.dataset.url) return;
    try {
      const url = sameOriginURL(el.dataset.url); url.search = new URLSearchParams({section_id:el.dataset.section,product_id:el.dataset.productId,limit:'4',intent:'related'}).toString();
      const html = await request(url); const next = $('[data-recommendations]',new DOMParser().parseFromString(html,'text/html'));
      if (next && !next.hidden && $('.ss-card',next)) { el.replaceWith(next); syncWishlist(); }
    } catch { /* Optional recommendations must not interrupt shopping. */ }
  }
  async function completeLookRecommendations() {
    const el = $('[data-complete-look-recommendations]');
    if (!el || !el.hidden || !el.dataset.url) return;
    try {
      const url = sameOriginURL(el.dataset.url);
      url.search = new URLSearchParams({section_id:el.dataset.section,product_id:el.dataset.productId,limit:'4',intent:'complementary'}).toString();
      const html = await request(url);
      const next = $('[data-complete-look-recommendations]',new DOMParser().parseFromString(html,'text/html'));
      if (next && !next.hidden && $('[data-complete-look]',next)) {
        el.replaceWith(next);
        lookState($('[data-complete-look]',next));
      }
    } catch { /* A missing recommendation must not interrupt shopping. */ }
  }
  function stickyBuy() {
    const info = $('.ss-product-info'), sticky = $('[data-sticky-buy]'); if (!info || !sticky || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(entries => { const entry = entries[0]; sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; },{rootMargin:'-85px 0px 0px 0px'}).observe(info);
  }
  function initializeDynamic() { $$('[data-country-default]').forEach(select => { if (select.dataset.countryDefault) select.value = select.dataset.countryDefault; }); bindSearch(); bindDialogs(); syncWishlist(); $$('[data-product-scope]').forEach(updatePlan); $$('[data-complete-look]').forEach(lookState); setDensity(parse(storage.get('ss:density'),'compact')); }
  document.addEventListener('shopify:section:load',() => { cardCache.clear(); initializeDynamic(); recentlyViewed(); recommendations(); completeLookRecommendations(); });
  initializeDynamic(); renderWishlist(); recentlyViewed(); recommendations(); completeLookRecommendations(); stickyBuy();
})();
